import React from "react";
import { Div } from "atomize";
import { graphql } from "gatsby";
import Header from "../components/common/Header";

import SEO from "../components/seo";
import Layout from "../components/common/layout";
import Footer from "../components/common/Footer";
import EngagementHero from "../components/engagementrates/EngagementHero";
import EngagementPoints from "../components/engagementrates/EngagementPoints";
import EngagementVideo from "../components/engagementrates/EngagementVideo";
import EngagementAudience from "../components/engagementrates/EngagementAudience";
import EngagementCreate from "../components/engagementrates/EngagementCreate";
import EngagementBuck from "../components/engagementrates/EngagementBuck";
import EngagementTestimonial from "../components/engagementrates/EngagementTestimonial";
import EngagementDashboard from "../components/engagementrates/EngagementDashboard";
import EngagementChannels from "../components/engagementrates/EngagementChannels";
import SolutionsLearnMore from "../components/common/SolutionsLearnMore";
import SolutionsFooter from "../components/common/SolutionsFooter";

const ImprovedEngagementRates = ({ data }) => {
  const content = JSON.parse(data.contentfulJson.json.json);

  return (
    <Layout>
      <SEO
        seo={data.contentfulJson.seo}
        url="https://trend.io/improved-engagement-rates"
      />
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <EngagementHero
        content={content.hero}
        form={
          data.contentfulGlobalConfig.improveEngagementRatesForm1
            .improveEngagementRatesForm1
        }
      />
      <EngagementPoints content={content.engagementPoints} />
      {/* <EngagementVideo content={content.engagementVideo} /> */}
      <EngagementAudience content={content.audience} />
      <Div m={{ t: "9.625rem" }}>
        <EngagementCreate
          content={content.create}
          form={
            data.contentfulGlobalConfig.improveEngagementRatesForm2
              .improveEngagementRatesForm2
          }
        />
      </Div>
      <EngagementBuck content={content.engagementBuck} />
      <EngagementTestimonial content={content.testimonial} />
      <Div d={{ xs: "none", md: "block" }} m={{ t: "8.44rem" }}>
        <EngagementDashboard content={content.dashboard} />
      </Div>
      <EngagementChannels content={content.channels} />
      <Div m={{ t: { xs: "8rem", md: "11.375rem" } }}>
        <SolutionsLearnMore
          content={content.LearnMoreContent}
          form={
            data.contentfulGlobalConfig.improveEngagementRatesForm3
              .improveEngagementRatesForm3
          }
        />
      </Div>
      <Div m={{ t: { xs: "4.5rem", md: "10.875rem" } }}>
        <SolutionsFooter content={content.footerContent} />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query SolutionPage3 {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulJson(contentful_id: { eq: "308MUpkAIvcJgl4MvhBuVz" }) {
      json {
        json
      }
      seo {
        ...SeoFragment
      }
    }

    contentfulGlobalConfig {
      improveEngagementRatesForm1 {
        improveEngagementRatesForm1
      }
    }

    contentfulGlobalConfig {
      improveEngagementRatesForm2 {
        improveEngagementRatesForm2
      }
    }

    contentfulGlobalConfig {
      improveEngagementRatesForm3 {
        improveEngagementRatesForm3
      }
    }
  }
`;

export default ImprovedEngagementRates;
